import { PendingApproval } from "../model/pendingApprovalModel";
import { PendingApprovalsAction } from "./pendingAction.action";

export interface JobPendingApprovalState {
  pendingApprovals: PendingApproval[];
  openMenuJobId: string | null;
  count: number;
  rejectModalOpen: boolean;
  rejectReason: string;
   toast: {
    isVisible: boolean;
    message: string;
    type: "success" | "error" | "warning" | "info";
  };
}
export const initialState: JobPendingApprovalState = {
  pendingApprovals: [],
  openMenuJobId: null,
  count: 0,
  rejectModalOpen: false,
  rejectReason: "",
  toast: {
    isVisible: false,
    message: "",
    type: "success",
  },
};

export const JobPendingApprovalReducer = (
  state: JobPendingApprovalState,
  action: PendingApprovalsAction,
): JobPendingApprovalState => {
  switch (action.type) {
    case "SET_PENDING_APPROVALS":
      return { ...state, pendingApprovals: action.payload };
    case "SET_OPEN_MENU":
      return { ...state, openMenuJobId: action.payload };
    case "SET_COUNT":
      return { ...state, count: action.payload };
      case "SET_STATUS_TOAST":
      return { ...state, toast: action.payload };
    case "OPEN_REJECT_MODAL":
      return {
        ...state,
        rejectModalOpen: true,

        rejectReason: "",
      };

    case "CLOSE_REJECT_MODAL":
      return {
        ...state,
        rejectModalOpen: false,

        rejectReason: "",
      };

    case "SET_REJECT_REASON":
      return {
        ...state,
        rejectReason: action.payload,
      };
    default:
      return state;
  }
};
